import { ReactNode } from 'react';

import { statusConfig } from '@/constants/status';

interface StatusLabelProps {
  status: string;
  flag?: 'yellow' | 'red' | null;
  showIcon?: boolean;
  className?: string;
  children?: ReactNode;
}

const FLAG_DOT: Record<string, string> = {
  yellow: 'bg-yellow-400',
  red: 'bg-red-500',
};

export function StatusLabel({
  status,
  flag,
  showIcon,
  className = '',
  children,
}: StatusLabelProps) {
  const found =
    statusConfig.find((s) => s.value === status) ||
    statusConfig.find((s) => s.value === 'unknown') ||
    statusConfig[statusConfig.length - 1];

  if (!found) {
    return null;
  }

  const StatusIcon = found.icon;

  return (
    <div
      className={`flex items-center justify-center gap-2 rounded-lg border px-3 py-1.5 ${found.color} ${className}`}
    >
      <div className="flex min-w-0 items-center justify-center gap-2">
        {showIcon && <StatusIcon size={14} strokeWidth={2.5} />}
        <span
          data-testid="status-label"
          data-flag={status === 'pending' && flag ? flag : undefined}
          className="truncate text-xs font-bold tracking-wider uppercase"
        >
          {found.label}
        </span>
        {status === 'pending' && flag && FLAG_DOT[flag] && (
          <span className={`size-2.5 shrink-0 rounded-xs ${FLAG_DOT[flag]}`} />
        )}
        {children}
      </div>
    </div>
  );
}
